<template>
    <section class="flex font-poppins md:flex-col">
        <div>
            <AdminDashboardNav/>
        </div> 
        <div class=" w-screen pl-10 pr-10 md:pl-1 md:pr-1">
            <section class="mt-6">
                <div class=" flex justify-between md:flex-col-reverse">
                    <div class="md:mt-6">
                        <GetDate/>
                        <p class="text-blue-700 font-bold text-2xl">MANAGE CARRIERS</p>
                    </div>

                    <div class=" mr-10">
                        <Notification/>
                    </div>
                </div>
            </section>
            
            <div class="mb-10 mt-20">
                <div class="flex">
                    <i class="fa fa-arrow-left mt-1 text-blue-700"></i>
                    <button class="text-sm ml-4 text-blue-700 cursor-pointer" @click="goBack" >Go Back</button>
                    <p class=" ml-8 font-semibold text-lg">Carrier's Information</p>
                    <i v-if="isLoading" class="fa  fa-spinner fa-spin  ml-4 text-blue-600"></i>    
                </div>
            </div>
            <div>
                <section class="flex justify-between md:flex-col">
                    <div class=" flex">
                        <img src="../assets/customer-pic1.png" alt="pic">
                        
                        <button class="mt-4 cursor-pointer rounded-2xl ml-6  border-blue-400 text-center p-2 bg-green-100 text-green-300 font-semibold" >
                            <span v-if="rider.status === 'approved' " class="pl-4 pr-4 text-red-500" @click="blockRider(rider)">Block</span>
                            <span v-if="rider.status === 'blocked' " class="pl-4 pr-4 text-red-500" @click="unblockRider(rider)">Unblock</span>
                            <span @click="approveRider" v-if="rider.status === 'pending' " class="pl-4 pr-4" style=" color: green;">Approve</span>

                        </button>
                        <div class="flex ml-6 border bg-gray-200 p-2  text-center mt-4 rounded-xl cursor-pointer">
                            <img class="w-5 h-5 mr-2" src="../assets/message-icon.png"/>
                            <router-link :to="{name: 'email-center'}">Send Email</router-link>
                        </div>
                    </div>

                    <div class="md:mt-4 md:text-right">
                        <button @click="deleteRiderModal(rider)" class="bg-red-100 text-red-600 rounded-xl p-2"><i class="fa fa-trash mr-2"></i>Delete</button>
                    </div>
                </section>

                <section class="flex justify-between mt-6 text-blue-600">
                    <div class="flex">
                        <img src="../assets/user-icon.svg" alt="user-icon">
                        <p class="ml-6">Profile Details</p>
                    </div>
                    
                    <div @click="showEdit" class="cursor-pointer">Edit Profile</div>

                    <div>
                        <p class="mr-28 cursor-pointer">Attachment(s)</p>
                    </div>
                </section>
                <hr>

                <section class="flex justify-between md:flex-col">
                    <div class="mt-6">
                        <div>
                            <div>
                                <div class="flex">
                                    <p> Status: </p>
                                    <p class="ml-10 text-blue-600">{{rider.status}}.</p>
                                </div>
                                <div class="flex mt-4">
                                    <p > Name: </p>
                                    <p class="ml-10 text-blue-600">{{rider.firstName}}  {{rider.lastName}}.</p>
                                </div>
                                 <div class="flex mt-4">
                                    <p > Email: </p>
                                    <p class="ml-10 text-blue-600">{{rider.email}}</p>
                                </div>
                                <div class="flex mt-4">
                                    <p >Phone Number:</p>  
                                    <p class="ml-10 text-blue-600">{{rider.phone}}.</p>
                                </div>
                                <div v-show="rider.vehicleType" class="flex mt-4">
                                    <p >Vehicle Type:</p>  
                                    <p class="ml-10 text-blue-600">{{rider.vehicleType}}.</p>
                                </div>
                                <div v-show="rider.vehicleModel" class="flex mt-4">
                                    <p >Vehicle Model:</p>  
                                    <p class="ml-10 text-blue-600">{{rider.vehicleModel}}.</p>
                                </div>
                                <div v-show="rider.vehicleYear" class="flex mt-4">
                                    <p >Vehicle Year:</p>  
                                    <p class="ml-10 text-blue-600">{{rider.vehicleYear}}.</p>
                                </div>
                                <div v-show="rider.licenseNumber" class="flex mt-4">
                                    <p >Plate Number:</p>  
                                    <p class="ml-10 text-blue-600">{{rider.licenseNumber}}.</p>
                                </div>
                                <div v-show="rider.chasisNumber" class="flex mt-4">
                                    <p >Chasis Number:</p>  
                                    <p class="ml-10 text-blue-600">{{rider.chasisNumber}}.</p>
                                </div>
                                <div v-show="rider.engineNumber" class="flex mt-4">
                                    <p >Engine Number:</p>  
                                    <p class="ml-10 text-blue-600">{{rider.engineNumber}}.</p>
                                </div>
                                <div v-show="rider.uniqueId" class="flex mt-4">
                                    <p >Unique ID:</p>  
                                    <p class="ml-10 text-blue-600">{{rider.uniqueId}}.</p>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div v-show="editProfile" class="mt-6">
                        <EditRiderInfo :id="rider.email" @getRider="getRider"/>
                    </div>

                    <div class=" mr-10 mt-6 w-1/3 md:w-full">

                        <div>
                            <div class="flex"> 
                                <div v-if="rider.passport && rider.passport.includes('pdf')" class="ml-8 w-1/3 h-32 rounded-xl bg-gray-200 border ">
                                    <p class="text-xs">Passport</p>
                                    <a :href="rider.passport" target="_blank"><img class="w-full h-32 " src="../assets/pdf.png" alt="Passport"></a>
                                </div>
                                <div v-else class="ml-8 w-1/3 h-32 rounded-xl bg-gray-200 border ">
                                    <p class="text-xs">Passport</p>
                                    <a :href="rider.passport" target="_blank"><img class="w-full h-32 " :src="rider.passport" alt="Passport"></a>
                                </div>

                                <div v-if="rider.idCard && rider.idCard.includes('pdf')" class="ml-8 w-1/3 h-32 rounded-xl bg-gray-200 border ">
                                    <p class="text-xs">ID Card</p>
                                    <a :href="rider.idCard" target="_blank"><img src="../assets/pdf.png" class="w-full h-32" alt="ID Card"></a>
                                </div>
                                <div v-else class="ml-8 w-1/3 h-32 rounded-xl bg-gray-200 border ">
                                    <p class="text-xs">ID Card</p>
                                    <a :href="rider.idCard" target="_blank"><img :src="rider.idCard" class="w-full h-32" alt="ID Card"></a>
                                </div>
                                
                            </div>

                            <div class="flex mt-8">
                                
                                <div v-if="rider.originCertificate && rider.originCertificate.includes('pdf')" class="ml-8 w-1/3 h-32 rounded-xl bg-gray-200 border ">
                                    <p class="text-xs">Origin Certificate</p>
                                    <a target="_blank" :href="rider.originCertificate"><img class="w-full h-32 " src="../assets/pdf.png" alt="Origin-Certificate"></a>
                                </div>
                                <div v-else class="ml-8 w-1/3 h-32 rounded-xl bg-gray-200 border ">
                                    <p class="text-xs">Origin Certificate</p>
                                    <a target="_blank" :href="rider.originCertificate"><img class="w-full h-32 " :src="rider.originCertificate" alt="Origin-Certificate"></a>
                                </div>
                                <div v-if="rider.lasra && rider.lasra.includes('pdf')" class="ml-8 w-1/3 h-32 rounded-xl bg-gray-200 border ">
                                    <p class="text-xs">Lasra</p>
                                    <a target="_blank" :href="rider.lasra"><img class="w-full h-32 " src="../assets/pdf.png" alt="lasra"></a>
                                </div>
                                <div v-else class="ml-8 w-1/3 h-32 rounded-xl bg-gray-200 border ">
                                    <p class="text-xs">Lasra</p>
                                    <a target="_blank" :href="rider.lasra"><img class="w-full h-32 " :src="rider.lasra" alt="lasra"></a>
                                </div>
                               
                            </div>

                            <div class="flex mt-8">
                                
                                <div v-if="rider.vehicleReceipt && rider.vehicleReceipt.includes('pdf')" class="ml-8 w-1/3 h-32 rounded-xl bg-gray-200 border ">
                                    <p class="text-xs">Vehicle Receipt</p>
                                    <a target="_blank" :href="rider.vehicleReceipt"><img class="w-full h-32 " src="../assets/pdf.png" alt="vehicle Receipt"></a>
                                </div>
                                <div v-else class="ml-8 w-1/3 h-32 rounded-xl bg-gray-200 border ">
                                    <p class="text-xs">Vehicle Receipt</p>
                                    <a target="_blank" :href="rider.vehicleReceipt"><img class="w-full h-32 " :src="rider.vehicleReceipt" alt="vehicle Receipt"></a>
                                </div>
                                <div v-if="rider.roadWorthiness && rider.roadWorthiness.includes('pdf')" class="ml-8 w-1/3 h-32 rounded-xl bg-gray-200 border ">
                                    <p class="text-xs">Road Worthiness</p>
                                    <a target="_blank" :href="rider.roadWorthiness"><img class="w-full h-32 " src="../assets/pdf.png" alt="Road Worthiness"></a>
                                </div>
                                <div v-else class="ml-8 w-1/3 h-32 rounded-xl bg-gray-200 border ">
                                    <p class="text-xs">Road Worthiness</p>
                                    <a target="_blank" :href="rider.roadWorthiness"><img class="w-full h-32 " :src="rider.roadWorthiness" alt="Road Worthiness"></a>
                                </div>
                               
                            </div>
                        </div>   
                            
                    </div>    
                </section>
            </div>
        </div> 
        <div>
            <DeleteModal
            v-show="deleteModal"
            @close="closeModal"
            :message="message"
            @getRiders="getRider"
            :riderId="riderId"
            />
        </div>
           
    </section>
</template>

<script>
import axios from 'axios';
import AdminDashboardNav from '../AdminDashboardNav.vue';
import GetDate from '../GetDate.vue';
import DeleteModal from './DeleteModal.vue';
import EditRiderInfo from './EditRiderInfo'
import Notification from '../Notification.vue';
import {baseUrl} from '../../../Config';
const url = baseUrl;
export default {
    props: ['id'],

    components : {
        AdminDashboardNav,
        GetDate,
        Notification,
        DeleteModal,
        EditRiderInfo
    },

    data() {
        return {
            riderInfo: true,
            pendingRiders: true,
            rider: [],
            isLoading: false,
            isActive: false,
            deleteStatus : "deleted",
            blockStatus: "blocked",
            unblockStatus: "approved",
            deleteModal: false,
            message: "",
            riderId: "",
            editProfile: false
        }
    },

    mounted() {
        this.getRider();
        this.networkError();
    },

    methods: {
        showEdit() {
            this.editProfile = !this.editProfile
        },
        toggleStatus() {
            if (!this.isActive) {
                this.isActive = true
            } else{
                this.isActive = false
            }
        },
        closeModal() {
            this.deleteModal = false;
        },
        deleteRiderModal(rider) {
            this.riderId = rider._id
            this.deleteModal = true;
            this.message =  "Are you sure you want to perform this action?"
        },

        goBack() {
            this.$router.go(-1)
        },


        getRider() {
             this.isLoading = true
            axios({
                method: 'GET',
                url: `${url}/v1/web/riders/check/${this.id}`,
                headers: {
                    'Content-type': 'application/json',
                    Authorization: 'Bearer' + localStorage.getItem("token"),
                    'cg-key':  '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3'
                },
            })
            .then((response)=> {
                this.rider = response.data.data
                this.isLoading = false
            })
            .catch((error) => {
                console.log(error)
            })
        },

        approveRider() {
            axios({
                method: 'PUT',
                url: `${url}/v1/web/riders/update/status/${this.rider._id}`,
                headers: {
                    Authorization: 'Bearer' + localStorage.getItem('token'),
                    'Content-type': 'application/json',
                    'cg-key':  '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3'
                },
                data : {
                    status : this.unblockStatus
                }
            })
            .then((response) => {
                this.getRider()
                response
            }) 
            .catch((error) => {
                console.log(error)
            })
        },


        blockRider(rider) {
            axios({
                method: 'PUT',
                url: `${url}/v1/web/riders/update/status/${rider._id}`,
                headers: {
                    Authorization: 'Bearer' + localStorage.getItem('token'),
                    'Content-type': 'application/json',
                    'cg-key':  '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3'
                },
                data : {
                    status : this.blockStatus
                }
            })
            .then((response) => {
                this.getRider()
                response;
            }) 
            .catch((error) => {
                console.log(error)
            })
        },

        unblockRider(rider) {
            axios({
                method: 'PUT',
                url: `${url}/v1/web/riders/update/status/${rider._id}`,
                headers: {
                    Authorization: 'Bearer' + localStorage.getItem('token'),
                    'Content-type': 'application/json',
                    'cg-key':  '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3'
                },
                data : {
                    status : this.unblockStatus
                }
            })
            .then((response) => {
                this.getRider()
                response;
            }) 
            .catch((error) => {
                console.log(error)
            })
        },


        networkError() {
            if(!navigator.onLine) {
                this.$router.push('/network-error')
            } 
        }
    }
}
</script>

